import { InjectionToken } from '@angular/core'

import { AppLanguage } from '../enums'

export type Tip = Record<AppLanguage, string>
export type TipsCollection = Record<'often' | 'rarely', Tip[]>

export const TIPS_DEFAULT_LANG = new InjectionToken<AppLanguage>('TIPS_DEFAULT_LANG', )
export const TIPS = new InjectionToken<TipsCollection>('TIPS')

export async function getRandomTip(tips: TipsCollection) {
	let rarely = tips.rarely || []
	let often = tips.often || []

	if (!rarely.length && !often.length) throw new Error('No enough available tips')
	if (!rarely.length) rarely = often
	if (!often.length) often = rarely

	return Math.random() < 0.4
		? rarely[~~(Math.random() * rarely.length)]
		: often[~~(Math.random() * often.length)]
}
